export default __webpack_public_path__ + "static/englet-8-4d38125e2034b98b1a46d1a570b557e2.jpg";